import i18n from 'i18next';

import { formatNumberByLocale } from '@/utils/localeFormatters';

export function formatWinchMeters(value: number | null | undefined, fallback = '–'): string {
    if (value == null || Number.isNaN(value)) {
        return fallback;
    }
    return formatNumberByLocale(value, i18n.language, 1, fallback);
}

export function formatWinchMeterChip(
    value: number | null | undefined,
    unit: string,
    fallback = '–'
): string {
    return `${formatWinchMeters(value, fallback)} ${unit}`;
}

export const WINCH_VALUE_STEP = 0.1;

export function isWithinLimit(value: number, min: number, max: number): boolean {
    return value >= min && value <= max;
}

export function isOutOfWinchLimit(value: number | null, min: number, max: number): boolean {
    return value == null || !isWithinLimit(value, min, max);
}
